export const musicLibrary = [
  {
    title: "Talk of the Town",
    src: "/music/talkofthetown.mp3",
    cover: "/images/covers/talkofthetown.jpg",
  },
  {
    title: "Talk of the Town",
    src: "/music/talkofthetown.mp3",
    cover: "/images/covers/talkofthetown.jpg",
  },
  {
    title: "Talk of the Town",
    src: "/music/talkofthetown.mp3",
    cover: "/images/covers/talkofthetown.jpg",
  },
];